export default "__VITE_ASSET__DwjWYgNs__"